import React from 'react'
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { IoMdClose } from "react-icons/io"
import StarRating from '../Rating/StarRating';
import { firestore } from '../../Firebase/Firebase';
import firebase from 'firebase/compat/app';
import { useAuth } from '../../context/AuthContext';
import { GrNext } from "react-icons/gr"
import { GrPrevious } from "react-icons/gr"
import Comments from '../Comments';

import { useHistory } from "react-router-dom"
import "./PostalModal.scss"
const MODAL_STYLES = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "transparent",
    padding: "50px",
    zIndex: 1000,
    overflowY: 'auto',
    height: "100%",
    width: "100%",
    scrollbarWidth: 'none',  // Hide scrollbar for Firefox
    '&::-webkit-scrollbar': {
        width: '0.5em',
        display: 'none',  // Hide scrollbar for Chrome, Safari, and Edge
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#F0F0F0 ',
        borderRadius: '1em',
    },
}

const OVERLAY_STYLE = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    zIndex: 1000,

}

function PostModal({ open, selectedPost, selectedIndex, setSelectedPost, onClose, posts, onDeletePost, loggedInUserId }) {
    const { currentUser } = useAuth();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [userSignedIn, setUserSignedIn] = useState(false); // New state to track if user is signed in

    useEffect(() => {
        // Check if the user is signed in
        if (currentUser) {
            setUserSignedIn(true);
        }
    }, [currentUser]);


    useEffect(() => {
        const originalOverflow = document.body.style.overflow; // Store the original overflow value

        // Disable scrolling on the background window when the modal is open
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling on the background window when the modal is closed
            document.body.style.overflow = originalOverflow;
        }

        // Cleanup: Revert the overflow property when the component unmounts or the open state changes
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, [open]);

    const history = useHistory();

    const handleCloseModal = () => {
        setSelectedPost(null);
        // Close the modal
        onClose();

        // Remove the id parameter from the URL
        history.push('/blog');
    };



    // Function to format the date from the Time
    const formatDate = (Time) => {
        if (!Time) return ''; // Handle the case when Time is undefined
        const dateObj = Time.toDate();
        const month = dateObj.toLocaleString('default', { month: 'long' });
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();
        return `${month} ${day}, ${year}`;
    };

    const [rating, setRating] = useState(0);

    useEffect(() => {
        // Initialize the rating state only when the modal opens for the first time
        if (open && selectedPost) {
            setRating(selectedPost.rating || 0);
        }
    }, [open, selectedPost]);

    const handleRatingChange = (newRating) => {
        if (!currentUser) {
            // If the user is not signed in, display the sign-up modal or take appropriate action
            // For example, you can show a sign-up dialog, redirect to the sign-up page, etc.
            console.log('User is not signed in. Display sign-up modal or redirect to sign-up page.');
            return;
        } else {
            // Update the rating state when the user clicks on a star
            setRating(newRating);

            // Get the reference to the specific rating document in the "ratings" subcollection
            const ratingRef = firestore
                .collection('Posts')
                .doc(selectedPost.id)
                .collection('ratings')
                .doc(currentUser.uid); // Replace 'user_id_here' with the user ID of the person giving the rating

            // Check if the user has already rated the post
            ratingRef
                .get()
                .then((docSnapshot) => {
                    if (docSnapshot.exists) {
                        // If the rating document exists, update it with the new rating and timestamp
                        ratingRef
                            .update({
                                rating: newRating,
                                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                                user: currentUser.uid,
                                name: currentUser.displayName,
                            })
                            .then(() => {
                                console.log('Rating updated in Firestore');
                            })
                            .catch((error) => {
                                console.error('Error updating rating in Firestore: ', error);
                            });
                    } else {
                        // If the rating document doesn't exist, create a new one with the new rating and timestamp
                        ratingRef
                            .set({
                                rating: newRating,
                                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                                user: currentUser.uid,
                                name: currentUser.displayName,
                            })
                            .then(() => {
                                console.log('Rating added to Firestore');
                            })
                            .catch((error) => {
                                console.error('Error adding rating to Firestore: ', error);
                            });
                    }
                })
                .catch((error) => {
                    console.error('Error checking rating in Firestore: ', error);
                });
        }

    };

    useEffect(() => {
        // Find the index of the selected post in the posts array
        if (selectedPost) {
            const index = posts.findIndex((post) => post.id === selectedPost.id);
            setCurrentIndex(index);
        }
    }, [selectedPost, posts]);


    // Function to navigate to the previous post
    const handlePrevPost = () => {

        if (currentIndex > 0) {
            const prevPost = posts[currentIndex - 1];
            setSelectedPost(prevPost);
            // Update the URL with the ID of the previous post
            history.push(`/blog/${prevPost.id}`);
        }
    };

    // Function to navigate to the next post
    const handleNextPost = () => {

        if (currentIndex < posts.length - 1) {
            const nextPost = posts[currentIndex + 1];
            setSelectedPost(nextPost);
            // Update the URL with the ID of the next post
            history.push(`/blog/${nextPost.id}`);
        }
    };

    const deletePost = () => {
        if (!selectedPost) return;

  

        // Only allow the post to be deleted if the currently logged-in user is the post creator
        if (loggedInUserId === selectedPost.uid) {
            const postRef = firestore.collection('Posts').doc(selectedPost.id);

            // Delete the post document from Firestore
            postRef
                .delete()
                .then(() => {
                    console.log('Post successfully deleted!');
                    onDeletePost(selectedPost.id); // Call the parent function to update the posts lists
                })
                .catch((error) => {
                    console.error('Error deleting post: ', error);
                });
        } else {
            console.log('You are not allowed to delete this post.');
        }
        onClose();
        history.push("/blog")
    }


    if (!open || !selectedPost) return null;
    return ReactDOM.createPortal(
        <>
            <div style={OVERLAY_STYLE} onClick={handleCloseModal} />
            <div className="closeBtn">
                <button onClick={handleCloseModal} className='modal-close-btn'><IoMdClose /></button>
            </div>
            <div className="navigy">
                <div className={`previ  ${currentIndex === 0 ? 'disabled-button' : ''}`}>
                    <button onClick={handlePrevPost} disabled={selectedIndex === 0}><GrPrevious /></button>
                </div>
                <div className={`nexty   ${currentIndex === posts.length - 1 ? 'disabled-button' : ''}`}>
                    <button onClick={handleNextPost} disabled={selectedIndex === posts.length - 1}><GrNext /></button>
                </div>
            </div>
            <div style={MODAL_STYLES} className='my-modal'>

                {selectedPost && (
                    <>
                        <div className="allMe">
                            {selectedPost.PhotoUrl ? (
                                <div className="ImageBound">
                                    <img src={selectedPost.PhotoUrl} alt="PostImage" className='ImageBound-img' />
                                </div>
                            ) : null}
                            <div className="content-container">
                                <div className="texti-out">
                                    <div className="texti">
                                        <p className='post-label'>{selectedPost.label} </p>
                                        <p className='author-name'>@{selectedPost.name} <span>- {formatDate(selectedPost.Time)}</span></p>
                                        <h2 className='PostTit'>{selectedPost.Title}</h2>
                                    </div>
                                    <div className="deleteMe">
                                        {loggedInUserId === selectedPost.uid && (
                                            <button onClick={deletePost} className="deleteButton">Delete Post</button>
                                        )}
                                    </div>
                                </div>
                                {userSignedIn ? (
                                    <div className="stars">
                                        <StarRating rating={rating} onRatingChange={handleRatingChange} />
                                    </div>
                                ) : (
                                    // Display the sign-up button or sign-up modal here
                                    <div className='PleaseSign'>
                                        <p className='Please'>Please sign up or sign in to rate this post.</p>

                                    </div>
                                )}
                                <div className="YourContent">
                                    <p dangerouslySetInnerHTML={{ __html: selectedPost.Content }}></p>
                                </div>

                                <div className="AllComments">
                                    <Comments postId={selectedPost.id} />
                                </div>

                            </div>
                        </div>
                    </>
                )}
            </div>


        </>,

        document.getElementById('portal')
    )
}

export default PostModal
